/*
 * WatchSurgeon product page redesign: delivery dates, single-option variant
 * pickers, engraving trigger visibility, travel case add-on and sticky buy bar.
 */
(() => {
  if (window.__wsPdp) return;
  window.__wsPdp = true;

  const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const pageLang = document.documentElement.lang || 'en';
  const lang = /^en\b/i.test(pageLang) ? 'en-GB' : pageLang;

  const addBusinessDays = (n) => {
    const d = new Date();
    let added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      const day = d.getDay();
      if (day !== 0 && day !== 6) added++;
    }
    return d;
  };
  const fmt = (d, withDay) =>
    d.toLocaleDateString(lang, withDay ? { weekday: 'short', day: 'numeric', month: 'short' } : { day: 'numeric', month: 'short' });

  function fillDates() {
    document.querySelectorAll('[data-ws-eta]').forEach((el) => {
      el.textContent = `${fmt(addBusinessDays(Number(el.dataset.min || 8)), true)} – ${fmt(addBusinessDays(Number(el.dataset.max || 10)), true)}`;
      const wrap = el.closest('[hidden]');
      if (wrap) wrap.hidden = false;
    });
    document.querySelectorAll('[data-ws-date]').forEach((el) => {
      const [a, b] = String(el.dataset.wsDate).split('-').map(Number);
      const prefix = el.dataset.prefix ? `${el.dataset.prefix} ` : '';
      if (!a) el.textContent = prefix + fmt(new Date());
      else if (b) el.textContent = `${prefix}${fmt(addBusinessDays(a))} – ${fmt(addBusinessDays(b))}`;
      else el.textContent = prefix + fmt(addBusinessDays(a));
    });
  }

  function hideSingleOptions() {
    document.querySelectorAll('[id^="MainProduct-"] variant-selects').forEach((selects) => {
      const groups = selects.querySelectorAll('fieldset, .product-form__input--dropdown');
      let hidden = 0;
      groups.forEach((group) => {
        if (group.querySelectorAll('input[type="radio"], option').length <= 1) {
          group.hidden = true;
          hidden++;
        }
      });
      if (groups.length && hidden === groups.length) selects.hidden = true;
    });
  }

  function syncEngravingTrigger() {
    const studio = document.getElementById('engraving-studio');
    const ready = !!studio && studio.style.display !== 'none';
    document.querySelectorAll('.ws-personalise [data-eng-trigger]').forEach((trigger) => {
      trigger.hidden = !ready;
    });
    document.querySelectorAll('.ws-personalise').forEach((box) => {
      box.hidden = ![...box.querySelectorAll('[data-eng-trigger], .ws-addon')].some((row) => !row.hidden);
    });
  }

  // Cart drawer stores re-render the drawer; cart notification stores refresh the bag count and "View cart" button.
  const NOTIFICATION_SECTIONS = ['cart-icon-bubble', 'cart-notification-button'];

  function renderCart(result, drawer) {
    if (drawer && drawer.renderContents) {
      drawer.renderContents(result);
      return;
    }
    NOTIFICATION_SECTIONS.forEach((id) => {
      const target = document.getElementById(id);
      const html = result.sections && result.sections[id];
      if (!target || !html) return;
      const source = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
      if (source) target.innerHTML = source.innerHTML;
    });
  }

  function setupTravelCase() {
    const addon = document.querySelector('[data-ws-addon]');
    if (!addon || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    let busy = false;
    subscribe(PUB_SUB_EVENTS.cartUpdate, async (event) => {
      if (!addon.checked || busy || !event) return;
      if (!['product-form', 'engraving-studio'].includes(event.source)) return;
      if (String(event.productVariantId) === addon.value) return;
      busy = true;
      try {
        const drawer = document.querySelector('cart-drawer');
        const sections = drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender().map((s) => s.id) : NOTIFICATION_SECTIONS;
        const result = await fetch(`${ROOT}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: Number(addon.value), quantity: 1 }],
            sections,
            sections_url: window.location.pathname,
          }),
        }).then((r) => r.json());
        renderCart(result, drawer);
        addon.checked = false;
      } catch (error) {
        console.warn('[ws] travel case could not be added', error);
      } finally {
        busy = false;
      }
    });
  }

  function setupStickyBar() {
    const bar = document.querySelector('[data-ws-sticky]');
    const submit = document.querySelector('[id^="MainProduct-"] .product-form__submit');
    if (!bar || !submit || !('IntersectionObserver' in window)) return;
    document.body.appendChild(bar);
    const button = bar.querySelector('button');
    new IntersectionObserver(([entry]) => {
      const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', String(!show));
      button.tabIndex = show ? 0 : -1;
    }).observe(submit);
    button.addEventListener('click', () => {
      if (submit.disabled) submit.scrollIntoView({ behavior: 'smooth', block: 'center' });
      else submit.click();
    });
  }

  function init() {
    fillDates();
    hideSingleOptions();
    syncEngravingTrigger();
    setupTravelCase();
    setupStickyBar();
    window.addEventListener('load', syncEngravingTrigger);
    setTimeout(syncEngravingTrigger, 1500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();